module.exports = __webpack_public_path__ + "img/num_26.bced4973.png";